import React from 'react';
import { observer } from 'mobx-react';
import { observable, when, computed } from 'mobx';
import { AppUI } from '@seedlang/state';
import autobind from 'autobind-decorator';
import Form from 'components/form_factory/form';
import FormFactory from 'components/form_factory/form_factory';
import styled from '@emotion/styled';
import Text from 'components/text';
import OutlineButton from 'components/button/outline_button';
import { Theme, TimeZones, Constants } from '@seedlang/constants';
import Alert from 'components/alert';
import SettingsUserImage from 'components/user/settings_user_image';
import { SettingsBillingWrapper } from '@seedlang/hoc';
import FormLabel from 'components/form_factory/form_label';
import { isPresent, isBlank } from '@seedlang/utils';
import SettingsUserLanguage from './settings_user_language';
import DeleteAccountModal from 'components/modal/delete_account_modal';

const Wrapper = styled.div`
  textarea {
    height: 80px!important;
  }
  h3 {
    text-align: center;
  }
`;

const Fields = styled.div`

`;

@observer
class SettingsUserProfile extends React.Component {
  @observable formLoaded = false;
  @observable showConfirmDeleteModal = false;
  @observable targetLanguageLevelsCache = {};

  constructor(props) {
    super(props);
    if (!AppUI.levelStore.hasIndexData) {
      AppUI.levelStore.getIndex();
    }
    when(() => {
      if (AppUI.userIsLoaded) {
        this.formLoaded = true;
        this.form = new FormFactory(AppUI.authUserStore, this.props);
        // AppUI.authUserStore.initializeForm();
      }
    });
  }

  @autobind onChangeUser(field, value) {
    AppUI.authUserStore.setFormCacheValue(field, value);
  }

  getValueUser(field) {
    return AppUI.authUserStore.formCache[field] || '';
  }

  @computed get streakExtendGoal() { // see user.rb
    if (isBlank(AppUI.authUserStore?.formCache?.dailyXpGoal)) { return AppUI.user?.streakExtendGoal; }
    return Math.max(100, AppUI.authUserStore?.formCache?.dailyXpGoal * 2);
  }

  fields() {
    return (
      <Fields>
        {
          AppUI.authUserStore.dirtyForm &&
            <Alert
              textAlign='center'
            >
              You have unsaved changes.
            </Alert>
        }
        {
          isPresent(AppUI.user?.email) && !AppUI.user.email.endsWith('@apple.com') && ! AppUI.user.email.endsWith('privaterelay.appleid.com') &&
            <div style={{margin: '0 0 20px 0'}}>
              <FormLabel name='Your Email'/>
              <Text>{AppUI.user?.email}</Text>
            </div>
        }
        { this.form.input({ margin: '0 0 20px 0', name: 'name', label: 'Your name', maxLength: Constants.MAX_NAME_LENGTH }) }
        { AppUI.siteIsDefault && this.form.input({ margin: '0 0 20px 0', name: 'location', label: 'Your location' }) }
        { AppUI.siteIsDefault && this.form.textarea({ margin: '0 0 20px 0', name: 'introduction', label: 'Your introduction' }) }
        { this.form.select({margin: '0 0 20px 0', name: 'timeZone', label: 'Your Time Zone', options: TimeZones})}
        <SettingsUserLanguage form={this.form} />
        {
          AppUI.siteIsDefault && this.form.flatSelect({
            margin: '0 0 20px 0',
            name: 'dailyXpGoal',
            label: 'Your Daily XP Goal',
            options: [
              { id: 15, name: 'Easy (15 XP per day)' },
              { id: 20, name: 'Regular (20 XP per day)' },
              { id: 30, name: 'Hard (30 XP per day)' },
              { id: 100, name: 'Extreme (100 XP per day)' },
              { id: 200, name: 'Insane (200 XP per day)' },
            ],
          })
        }
        {
          AppUI.siteIsDefault && this.form.toggle({
            margin: '0 0 20px 0',
            name: 'enableStreakExtension',
            label: `Get an extra Streak day at ${this.streakExtendGoal} XP`,
          })
        }
        {
          AppUI.siteIsDefault && this.form.toggle({
            margin: '0 0 20px 0',
            name: 'blockUserTracking',
            label: 'Block tracking of user activity',
          })
        }
        {
          AppUI.siteIsDefault && this.form.toggle({
            margin: '0 0 20px 0',
            name: 'hideOnLeaderboard',
            label: 'Hide my name on leaderboards',
          })
        }
        {
          AppUI.siteIsDefault && this.form.toggle({
            margin: '0 0 20px 0',
            name: 'hideTriviaRecord',
            label: 'Hide my trivia win/loss record',
          })
        }
      </Fields>
    );
  }

  render() {
    return (
      <Wrapper>
        {
          this.showConfirmDeleteModal &&
            <DeleteAccountModal
              onClose={() => this.showConfirmDeleteModal = false}
              activeStripeSubscriptionExists={this.props.activeStripeSubscriptionExists}
            />
        }
        <Text
          heading='3'
          margin='0 0 20px 0'
        >
          User Settings
        </Text>
        <SettingsUserImage />
        {
          this.formLoaded &&
            <Form
              form={this.form}
              fields={this.fields()}
              {...this.props}
            />
        }
        <OutlineButton
          selectedBackground={AppUI.siteIsDefault ? '#CCC' : Theme.red}
          margin='10px 0 0 0'
          onClick={() => this.showConfirmDeleteModal = true}
        >
          Delete Account
        </OutlineButton>
      </Wrapper>
    );
  }
}

export default SettingsBillingWrapper(SettingsUserProfile);
